import React from 'react';

export const NotFound = () => (<p>404 Not Found</p>);
